import { Box, Text, Triangle, useLayout } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { RetainStatusLabelProps } from './RetainStatusLabel.types';
import { getTriangleAlignItems } from './RetainStatus.utils';

function RetainStatusLabel({
  keepStatusNumberOfBoxes,
  promotionNumberOfBoxes,
  numberOfSectors,
}: RetainStatusLabelProps) {
  const [layout, onLayout] = useLayout();

  if (!keepStatusNumberOfBoxes || !promotionNumberOfBoxes) {
    return null;
  }

  const isFirstGem = keepStatusNumberOfBoxes === 1;
  const isLastGem = keepStatusNumberOfBoxes === promotionNumberOfBoxes;

  const transformAmount =
    layout.width && !isFirstGem && !isLastGem ? -layout.width / 2 : 0;

  return (
    <Box
      flexDirection="row"
      justifyContent={isLastGem ? 'flex-end' : 'flex-start'}
      paddingHorizontal={isLastGem || isFirstGem ? 'space-0' : 'space-400'}
      paddingBottom="space-100"
    >
      {!isFirstGem && !isLastGem ? (
        <Box
          width={`${(100 / numberOfSectors) * (keepStatusNumberOfBoxes - 1)}%`}
        />
      ) : null}
      <Box onLayout={onLayout} transform={`translateX(${transformAmount}px)`}>
        <Box
          backgroundColor="secondaryBackground"
          padding="space-100"
          borderRadius="radius-200"
        >
          <Text
            variant="badge"
            locNS="status"
            locKey="retainStatus"
            color="darkSurfacePrimary"
          />
        </Box>
        <Box
          alignItems={getTriangleAlignItems(isFirstGem, isLastGem)}
          paddingHorizontal="space-300"
        >
          <Triangle
            backgroundColor="secondaryBackground"
            size={6}
            direction="down"
          />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(RetainStatusLabel);
